import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { omit, isEqual } from 'lodash-es';

const US_PHONE_REGEX = new RegExp(/^([0-9]{10})$/);

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.toString().match(US_PHONE_REGEX);
    return isValid ? null : { notPhone: true };
  };
}

export function duplicatePhoneValidator(
  primaryPhoneControlName: string,
  secondaryPhoneControlName: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const primaryPhoneControl = control.get(primaryPhoneControlName);
    const secondaryPhoneControl = control.get(secondaryPhoneControlName);

    if (!primaryPhoneControl?.value || !secondaryPhoneControl?.value) return null;

    if (primaryPhoneControl.value === secondaryPhoneControl.value) {
      primaryPhoneControl.setErrors({ ...primaryPhoneControl.errors, isPhoneDuplicate: true });
      secondaryPhoneControl.setErrors({ ...secondaryPhoneControl.errors, isPhoneDuplicate: true });
      return { isPhoneDuplicate: true };
    } else {
      const newPrimaryPhoneControlError = omit(primaryPhoneControl.errors, 'isPhoneDuplicate');
      if (isEqual(newPrimaryPhoneControlError, {})) {
        primaryPhoneControl.setErrors(null);
      } else {
        primaryPhoneControl.setErrors(newPrimaryPhoneControlError);
      }
      const newSecondaryPhoneControlError = omit(secondaryPhoneControl.errors, 'isPhoneDuplicate');
      if (isEqual(newSecondaryPhoneControlError, {})) {
        secondaryPhoneControl.setErrors(null);
      } else {
        secondaryPhoneControl.setErrors(newSecondaryPhoneControlError);
      }
      return null;
    }
  };
}
